/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerDeleteMutationResponse,
  TelegramProductsUserControllerDeletePathParams,
  TelegramProductsUserControllerDelete401,
} from '../../types/TelegramProductsUserControllerDelete.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsUserDelete } from '../../methods/telegramProductsUserDelete.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsUserDeleteMutationKey = () => [{ url: '/api/user/telegram/products/:id' }] as const;

export type TelegramProductsUserDeleteMutationKey = ReturnType<typeof telegramProductsUserDeleteMutationKey>;

/**
 * {@link /api/user/telegram/products/:id}
 */
export function useTelegramProductsUserDelete<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsUserControllerDeleteMutationResponse,
      ResponseErrorConfig<TelegramProductsUserControllerDelete401>,
      { id: TelegramProductsUserControllerDeletePathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsUserDeleteMutationKey();

  return useMutation<
    TelegramProductsUserControllerDeleteMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerDelete401>,
    { id: TelegramProductsUserControllerDeletePathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return telegramProductsUserDelete(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
